import axios from 'axios';

/* ------------------------------------------------------------------ */
/* CONFIG AXIOS                                                       */
/* ------------------------------------------------------------------ */
const API = axios.create({
  baseURL: 'https://api.myseraph.eu/api/v1',
});

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

/* ------------------------------------------------------------------ */
/* ENTRY-LEVEL PRICE (opzionale)                                      */
/* ------------------------------------------------------------------ */
export const fetchEntryLevelPrice = async payload => {
  try {
    const { headers } = authHeaders();

    if (!payload?.category_id || payload.price_range == null) return null;

    const { data } = await API.post(
      '/prezzo-entry-level',
      payload,
      { headers: { 'Content-Type': 'application/json', ...headers } }
    );

    return data?.prezzo ?? null;
  } catch (err) {
    console.error('Errore prezzo entry-level', err);
    return null;
  }
};

/* ------------------------------------------------------------------ */
/* AUTH                                                               */
/* ------------------------------------------------------------------ */
export const loginUser      = (email, password) => API.post('/login', { email, password });

/* Users */
export const getUserById    = id   => API.get(`/users/${id}`,        authHeaders());
export const updateUser     = (id,d) => API.put(`/users/${id}`,  d,  authHeaders());
export const changePassword = (id,d) => API.post(`/users/${id}/change-password`, d, authHeaders());

/* Customers */
export const getCustomerById = id => API.get(`/customers/${id}`, authHeaders());

/* Companies */
export const registerCompany = d      => API.post('/companies/register', d);
export const deleteCompany   = id     => API.delete(`/companies/${id}`);
export const registerAdmin   = (cid,d)=> API.post(`/companies/${cid}/register-admin`, d);

/* Products & lookup */
export const fetchProducts        = ()   => API.get('/products',         authHeaders());
export const fetchProductById     = id   => API.get(`/products/${id}`,   authHeaders());
export const fetchBrands          = ()   => API.get('/brands').then(r => r.data);
export const fetchCategories      = ()   => API.get('/categories').then(r => r.data);
export const fetchFamilies        = ()   => API.get('/families').then(r => r.data);
export const fetchUnitsOfMeasure  = ()   => API.get('/unit-of-measures').then(r => r.data);
export const fetchSubCategories   = ()   => API.get('/sub-categories', authHeaders()).then(r => r.data);

/* Quotes */
export const getQuotesByUserId  = uid => API.get(`/quotes/user/${uid}`,     authHeaders());
export const fetchQuoteById     = id  => API.get(`/quotes/${id}`,           authHeaders());
export const fetchQuoteProducts = qid => API.get(`/quotes/${qid}/products`, authHeaders());
export const createQuote        = d   => API.post('/quotes',         d,     authHeaders());
export const createQuoteProduct = d   => API.post('/quote-products', d,     authHeaders());
export const getQuoteStatusById = id  => API.get(`/quote-statuses/${id}`,   authHeaders());

/* Models & periodicità */
export const fetchModels        = ()  => API.get('/models',         authHeaders());
export const fetchPeriodicities = ()  => API.get('/periodicities',  authHeaders());
export const fetchModelProducts = ()  => API.get('/model-products', authHeaders());
export const fetchCustomerRoles = id  => API.get(`/customer-roles/${id}`, authHeaders());
export const fetchSlas          = ()  => API.get('/sla',            authHeaders());

/* ------------------------------------------------------------------ */
/* QUOTE BUILDER                                                      */
/* ------------------------------------------------------------------ */
export const fetchFilteredProducts = params =>
  API.get('/quote-builder/products', { params, ...authHeaders() });

export const recalculateProduct = data =>
  API.post('/quote-builder/recalculate', data, authHeaders());

export default API;
